// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"bfed5179","227":"6e4a00f7","232":"6bd1471a","237":"f39026cd","357":"24fd23eb","526":"d3d1dc65","573":"aa6a2afb","872":"fee92302"}[chunkId] + ".chunk.js";
};